import React, { useMemo } from 'react';
import useAllDashboardTemplateOptions from './useAllDashboardTemplateOptions';
import { NEW_DASHBOARD_SETTINGS } from './utils';
import { CustomOption } from './types';
import ReactSelectAccordion from './ReactSelectAccordion';
import { colors } from '../../../../config/styles';

interface IProps {
  value: string;
  onChange: (value: string) => void;
  hasError?: boolean;
}

const AddToDashboardSelect = ({ value, onChange, hasError }: IProps) => {
  const handleSelectChange = (option: CustomOption | null) => {
    onChange(option?.value ?? '');
  };

  const { loading, options } = useAllDashboardTemplateOptions();

  const selectedOption = useMemo<CustomOption | null>(() => {
    if (!value) {
      return null;
    }

    if (value === NEW_DASHBOARD_SETTINGS.key) {
      return {
        value,
        label: NEW_DASHBOARD_SETTINGS.menuLabel,
      };
    }

    let label = '';

    options.forEach((option) => {
      if (option?.subOptions) {
        option.subOptions.forEach((subOption) => {
          if (subOption.value === value) {
            label = subOption.label;
          }
        });
      }
    });

    return {
      value,
      label,
    };
  }, [options, value]);

  return (
    <ReactSelectAccordion
      value={selectedOption}
      onChange={handleSelectChange}
      options={options}
      isDisabled={loading}
      styles={{
        control: (base) => {
          if (hasError) {
            return {
              ...base,
              borderColor: colors.mainError,
            };
          }

          return base;
        },
      }}
    />
  );
};

export default AddToDashboardSelect;
